// Styles for ProfilePageSections go here.
import styled from 'styled-components';

export const StyledProfileSection = styled.div``;
